<template>
  <CommonPages id="disclaimer" :class="['resources-page']" titlePrefix="Disclaimer"
    :metaDescription="domainConfig?.['meta']?.des || 'Disclaimer'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Disclaimer</h2>

        <div class="resources__content">
          <p>
            Welcome to {{ domainConfig?.siteName }}. We are proud to offer a collection of
            AI-generated novels designed to entertain and inspire our readers. Please take note of
            the following important information regarding our content:
          </p>
        </div>

        <!-- AI-Generated Content -->
        <h3 class="resources__subtitle">AI-Generated Content</h3>
        <div class="resources__content">
          <p>
            All stories and narratives on this website are created by advanced artificial
            intelligence algorithms. Our AI is trained on a diverse range of genres and styles to
            produce unique and imaginative content.
          </p>
        </div>

        <!-- Fictional Nature -->
        <h3 class="resources__subtitle">Fictional Nature</h3>
        <div class="resources__content">
          <p>
            The stories on {{ domainConfig?.siteName }} are purely fictional. Any resemblance to
            actual persons, living or dead, or real events is entirely coincidental. Our AI crafts
            narratives that are meant to be creative and engaging, without reference to real-world
            situations.
          </p>
        </div>

        <!-- Creative Exploration -->
        <h3 class="resources__subtitle">Creative Exploration</h3>
        <div class="resources__content">
          <p>
            We aim to explore new frontiers in storytelling through AI technology. While the AI
            generates the content, we ensure that it aligns with our mission to provide
            high-quality, imaginative literature.
          </p>
        </div>

        <!-- Content Review -->
        <h3 class="resources__subtitle">Content Review</h3>
        <div class="resources__content">
          <p>
            Although generated by AI, all content is reviewed to ensure it meets our standards for
            quality and creativity. We strive to provide a safe and enjoyable experience for all
            users.
          </p>
        </div>

        <!-- User Discretion -->
        <h3 class="resources__subtitle">User Discretion</h3>
        <div class="resources__content">
          <p>
            We encourage readers to approach our content with an open mind and an understanding of
            its AI-generated nature. The narratives are crafted to entertain, and we hope they
            inspire your imagination.
          </p>
        </div>

        <!-- Feedback and Improvement -->
        <h3 class="resources__subtitle">Feedback and Improvement</h3>
        <div class="resources__content">
          <p>
            We value feedback from our readers and are continually working to improve our AI's
            capabilities. If you have any comments or suggestions, please feel free to contact us at
            {{ domainConfig?.siteName }}.
          </p>
          <p>
            Thank you for visiting {{ domainConfig?.siteName }}. We hope you enjoy exploring the
            limitless possibilities of AI-generated storytelling.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'Disclaimer',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script> 